define('OutSystems/ReactView/CallbackManager',["require", "exports", "OutSystems/ClientRuntime/Logger", "OutSystems/ClientRuntime/Settings"], function (require, exports, Logger, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CallbackManager = void 0;
    var CallbackManager = (function () {
        function CallbackManager() {
            this.listeners = new Set();
        }
        CallbackManager.isFeatureEnabled = function () {
            return (0, Settings_1.getEnvParams)().EnableOnReadyTriggerFromBFCache;
        };
        CallbackManager.prototype.subscribe = function (callback) {
            var _this = this;
            if (!CallbackManager.isFeatureEnabled())
                return;
            this.listeners.add(callback);
            Logger.trace(this, function () { return "Subscribe | total " + _this.listeners.size; });
        };
        CallbackManager.prototype.unsubscribe = function (callback) {
            var _this = this;
            if (!CallbackManager.isFeatureEnabled())
                return;
            this.listeners.delete(callback);
            Logger.trace(this, function () { return "Unsubscribe | total " + _this.listeners.size; });
        };
        CallbackManager.prototype.broadcast = function () {
            var _this = this;
            if (!CallbackManager.isFeatureEnabled())
                return;
            this.listeners.forEach(function (callback) { return callback(); });
            Logger.trace(this, function () { return "Broadcast | total " + _this.listeners.size; });
        };
        CallbackManager.prototype.clearAll = function () {
            if (!CallbackManager.isFeatureEnabled())
                return;
            this.listeners.clear();
            Logger.trace(this, function () { return "Clear all listeners"; });
        };
        CallbackManager.getInstance = function () {
            if (!CallbackManager.instance) {
                CallbackManager.instance = new CallbackManager();
            }
            return CallbackManager.instance;
        };
        return CallbackManager;
    }());
    exports.CallbackManager = CallbackManager;
});
//# sourceMappingURL=CallbackManager.js.map;
